import React, { Component } from 'react';
import './index.css';

import State from '../State'

class SortControl extends Component {

  handleToggleSort() {
    State.action('toggleSortByValue')
  }

  render() {
    return (
      <div className="sort-control">
        <div className="subtitle">Sort by:</div>
        <div className="inner">
          <svg width="200px" height="24px">
            <g transform="translate(100,4)">
              <path transform="translate(-80, 2)" d="M0,0 l-10,6 l10,6 z" onClick={this.handleToggleSort} />
              <text className="no-select" y="13">{State.sortByValue ? 'Total expenditure' : 'Name / Date'}</text>
              <path transform="translate(80, 2)" d="M0,0 l10,6 l-10,6 z" onClick={this.handleToggleSort} />
            </g>
          </svg>
        </div>
      </div>
    )
  }
}

export default SortControl



// WEBPACK FOOTER //
// ./src/SortControl/index.js